// extracted by mini-css-extract-plugin
export var banner = "_h7-0";
export var closeButton = "_h7-2";
export var greenCheckmark = "_h7-3";
export var hereLink = "_h7-4";
export var titleIcon = "_h7-1";